












































































import { formatDate } from '@/web/utils/format';
import { errorToMessage } from '@/core/utils/errors';
import Vue from 'vue';

export default Vue.extend({
  name: 'QuizSubmissionsTable',
  props: {
    query: {
      type: Object,
    },
    quizId: {
      type: Number,
    },
    isGradable: {
      type: Boolean,
    },
  },
  data() {
    return {
      tableFields: [
        {
          name: 'name',
          title: this.$t('QUIZZES.TABLE.NAME'),
          cssClass: 'h5',
        },
        {
          name: 'email',
          title: this.$t('QUIZZES.TABLE.EMAIL'),
        },
        {
          name: 'status',
          title: this.$t('QUIZZES.TABLE.STATUS'),
          cssClass: 'c-charcoal',
        },
        {
          name: 'created',
          title: this.$t('QUIZZES.TABLE.DATE_TAKEN'),
        },
        {
          name: 'delete',
          shrink: true,
          cssClass: 'p-0',
        },
        {
          name: 'action',
          shrink: true,
          cssClass: 'p-0 text-center',
        },
      ],
    };
  },
  methods: {
    formatDate(date: string): string {
      if (!date) return '';
      return formatDate(date, 'date-time');
    },
    getStatus(solvedQuizData) {
      if (this.isGradable) {
        if (solvedQuizData.is_graded) {
          if (solvedQuizData.is_passed) {
            return this.$t('QUIZZES.STATUS.PASSED');
          } else {
            return this.$t('QUIZZES.STATUS.FAILED_WITH_SCORE', {
              score: solvedQuizData.grade_achieved_score,
            });
          }
        } else {
          // not yet graded
          return this.$t('QUIZZES.STATUS.REVIEW');
        }
      } else {
        return this.$t('QUIZZES.STATUS.SUBMITTED');
      }
    },
    formatStatus(solvedQuizData) {
      if (this.isGradable) {
        if (solvedQuizData.is_graded) {
          if (solvedQuizData.is_passed) {
            return 'passed';
          } else {
            return 'failed';
          }
        } else {
          return 'review';
        }
      } else {
        return 'submitted';
      }
    },
    async removeSubmission(submissionId) {
      console.log('delete ', submissionId);
      try {
        await this.$store.dispatch('quiz/deleteQuizSubmission', {
          quizId: this.quizId,
          submissionId,
        });
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS') as string,
          text: this.$t(
            'QUIZZES.NOTIFICATIONS.QUIZ_SUBMISSION_SUCCESSFULLY_DELETED'
          ) as string,
        });

        this.$refs.submissionsTable.refresh();
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR'),
          text: errorToMessage(
            error?.response,
            `${this.$t(
              'QUIZZES.NOTIFICATIONS.FAILED_TO_DELETE_QUIZ_SUBMISSION'
            )}: ${error}`
          ),
          duration: -1,
        });
      }
    },
  },
});
